module.exports = __webpack_public_path__ + "images/patterns/light/StripeVertical.302d24d5949e72499db2.svg";